import Vue from 'vue'

import './el_components'

import '@/styles/index.scss'

import './rem'

import './Bmap'

import CountryFlag from 'vue-country-flag'
Vue.component('CountryFlag', CountryFlag)
